import './Ecosystem.css';

const partners = [
  'Banks & NBFCs',
  'Government Bodies',
  'Farmer Producer Organisations',
  'Women Self-Help Groups',
  'Rural NGOs',
  'Agri Universities',
];

const activities = [
  { img: '/images/ecosystem_farmer.jpg', title: 'Farmer Engagement', desc: 'Direct linkages with farmers — providing fair pricing, technical support, and demand intelligence.' },
  { img: '/images/ecosystem_skilling.jpg', title: 'Youth Skilling', desc: 'Job-relevant skilling programmes for rural youth, matched to the needs of our portfolio businesses.' },
  { img: '/images/ecosystem_ai.png', title: 'AI for Rural', desc: 'Infusing AI and data tools across our supply chain operations with due consideration to rural constraints.' },
  { img: '/images/ecosystem_govt.jpg', title: 'Ecosystem Building', desc: 'Convening banks, governments, farmer groups, NGOs, and others around shared rural opportunities.' },
];

export default function Ecosystem() {
  return (
    <section className="ecosystem">
      <div className="ecosystem-inner">
        <div className="ecosystem-header">
          <p className="section-label">What makes us different</p>
          <h2 className="section-title">More than just business.</h2>
          <div className="divider" />
          <p className="section-body">
            Beyond capital allocation and business operations, we actively engage in 
            allied impact activities that unlock synergies with other ecosystem players.
          </p>
        </div>

        <div className="activities-grid">
          {activities.map(a => (
            <div className="activity-card" key={a.title}>
              <div className="activity-img-wrap">
                <img src={a.img} alt={a.title} className="activity-img" />
              </div>
              <div className="activity-body">
                <h3 className="activity-title">{a.title}</h3>
                <p className="activity-desc">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="ecosystem-partners">
          <p className="partners-label section-label">Ecosystem Partners</p>
          <div className="partners-wrap">
            {partners.map(p => (
              <span key={p} className="partner-tag">{p}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
